import { authPut } from "@api/auth/auth";

import { ActionBody, ActionResponse } from "@pages/settings/types";
/**
 * Sends request to update the action with id actionId
 * Recommended that you use the useDeleteAction react-query mutation instead
 */
export const updateAction = (
  deploymentId: string,
  actionId: number,
  actionBody: ActionBody
) => {
  return authPut<ActionBody, ActionResponse>(
    `/api/agent/deployments/${deploymentId}/actions/${actionId}`,
    actionBody
  );
};
